module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('company-client-typeahead'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "alert alert-warning text-center"
  }, [_c('span', {
    staticClass: "pre",
    domProps: {
      "textContent": _vm._s(_vm.companyCallCenter.messageTextPre)
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "short",
    domProps: {
      "textContent": _vm._s(_vm.companyCallCenter.messageTextShort)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "post",
    domProps: {
      "textContent": _vm._s(_vm.companyCallCenterMessageTextPost)
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "60px",
      "border-bottom": "1px solid #CCC"
    }
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-home ",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        Callcenter: " + _vm._s(_vm.companyCallCenter.name) + " \n        "), _c('a', {
    staticStyle: {
      "padding-left": "10px",
      "font-size": "16px"
    },
    attrs: {
      "target": "_blank",
      "href": "https://cc-pronto3.cmx-solutions.com/admin/main.php?mode=cfg"
    }
  }, [_vm._v("Administration")]), _vm._v(" "), _c('div', {
    staticClass: "small pull-right"
  }, [_vm._v("\n          ACD:\n          "), (_vm.acdText == 'Off') ? _c('span', [_vm._v("nicht eingrichtet!")]) : _c('span', [_vm._v(_vm._s(_vm.acdText))]), _vm._v(" "), (_vm.acdText != 'Off' && !_vm.acdIntervalStatus) ? _c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "title": "Automatische ACD Statusabfrage starten"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.ccCompanyAcd.startInterval()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play ",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.acdText != 'Off' && _vm.acdIntervalStatus) ? _c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "title": "Automatische ACD Statusabfrage stoppen"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.ccCompanyAcd.stopInterval()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pause ",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.acdText != 'Off') ? _c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "title": "refresh status"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.ccCompanyAcd.refresh()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh ",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "calc(100% - 170px)"
    }
  }, [_c('div', {
    staticClass: "col-xs-8",
    staticStyle: {
      "border-right": "1px solid #CCC",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "cc-memo-list"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "company-client-memo-accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, _vm._l((_vm.memos), function(memo, index) {
    return _c('cc-memo', {
      key: memo.id,
      staticClass: "panel cc-panel-default cc-memo-item",
      attrs: {
        "collapseIn": false,
        "data_parent": 'company-client-memo-accordion',
        "memo": memo
      },
      on: {
        "remove": _vm.onRemoveMemo,
        "update": _vm.onSetMemo
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.memos.length),
      expression: "!memos.length"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Keine internen Vorgaben")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('cc-company-acd', {
    ref: "ccCompanyAcd",
    on: {
      "status": _vm.onAcdStatus
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4817a1dd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CompanyCallCenter.vue
// module id = 273
// module chunks = 0